import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import './NumberedItem.css';

export const NumberedItem = ({
  number,
  numberColor,
  title,
  titleColor,
  children,
  bodyCopyColor,
}) => {
  const numberClasses = cx('numbered-item__number', `numbered-item__number-color--${numberColor}`);
  const titleClasses = cx('numbered-item__title', `numbered-item__title-color--${titleColor}`);
  const bodyCopyClasses = cx(
    'body-copy',
    'numbered-item__body',
    { 'body-copy--light-gray': bodyCopyColor === 'lightGray' },
    { 'body-copy--primary-gray': bodyCopyColor === 'primaryGray' }
  );
  return (
    <div className="numbered-item">
      <span className={numberClasses}>{number}. </span>
      <h3 className={titleClasses}>{title}</h3>
      <div className={bodyCopyClasses}>{children}</div>
    </div>
  );
};

NumberedItem.propTypes = {
  number: PropTypes.number,
  numberColor: PropTypes.oneOf(['teal']),
  title: PropTypes.string,
  titleColor: PropTypes.oneOf(['navy']),
  bodyCopyColor: PropTypes.oneOf(['primaryGray', 'lightGray']),
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};
export default NumberedItem;
